// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e9-a";
export var fulfillmentFormRail = "_e9-9";
export var headerTitleRow = "_e9-c";
export var orderDetailsWrapper = "_e9-7";
export var orderLinkTrigger = "_e9-2";
export var paymentInformationGrid = "_e9-h";
export var paymentSummaryColumn = "_e9-i";
export var shipmentContainer = "_e9-b";
export var shipmentDetailsMainPane = "_e9-8";
export var shipmentNavigationCard = "_e9-5";
export var shipmentNavigationRail = "_e9-3";
export var shipmentNavigationRailHeader = "_e9-4";
export var shipmentSummaryFact = "_e9-e";
export var shipmentSummaryGrid = "_e9-d";
export var shipmentSummaryMetadataRow = "_e9-f";
export var shipmentSummaryTags = "_e9-g";
export var shipmentWorkspace = "_e9-0";
export var shipmentWorkspaceContent = "_e9-6";
export var shipmentWorkspaceHeader = "_e9-1";